import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "calculator-box-content" }
const _hoisted_2 = {
  key: 0,
  class: "calculator-interaction"
}
const _hoisted_3 = { class: "calculator-interaction-lines" }
const _hoisted_4 = { class: "calculator-interaction-dots" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "calculator-interaction-whitespace" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "calculator-interaction-dot" })
], -1)
const _hoisted_7 = { class: "calculator-interaction-info" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "calculator-title calculator-title-first"
}
const _hoisted_10 = { class: "form__label--rubik calculator-input_label" }
const _hoisted_11 = { class: "calculator-lgflex" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form__label--rubik form__label--thin" }
const _hoisted_14 = {
  key: 0,
  class: "calculator-field-required"
}
const _hoisted_15 = { class: "calculator-3table" }
const _hoisted_16 = { class: "form__label--rubik calculator-input_label" }
const _hoisted_17 = {
  key: 0,
  class: "calculator-field-required"
}
const _hoisted_18 = { class: "form__label--rubik calculator-input_label" }
const _hoisted_19 = {
  key: 0,
  class: "calculator-field-required"
}
const _hoisted_20 = { class: "form__label--rubik calculator-input_label" }
const _hoisted_21 = {
  key: 0,
  class: "calculator-field-required"
}
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  key: 0,
  class: "calculator-title"
}
const _hoisted_24 = { class: "calculator-title-info" }
const _hoisted_25 = {
  key: 1,
  class: "calculator-subtitle"
}
const _hoisted_26 = { class: "calculator-3table" }
const _hoisted_27 = { class: "form__label--rubik calculator-input_label" }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = {
  key: 0,
  class: "calculator-title"
}
const _hoisted_30 = {
  key: 1,
  class: "calculator-subtitle calculator-subtitle-mb-15"
}
const _hoisted_31 = { class: "calculator-3table" }
const _hoisted_32 = { class: "calculator-table" }
const _hoisted_33 = { class: "calculator-value" }
const _hoisted_34 = { class: "calculator-value" }
const _hoisted_35 = { class: "calculator-table" }
const _hoisted_36 = { class: "calculator-value" }
const _hoisted_37 = { class: "calculator-value" }
const _hoisted_38 = {
  key: 2,
  class: "calculator-subtitle calculator-subtitle-mb-15"
}
const _hoisted_39 = { class: "calculator-3table" }
const _hoisted_40 = { class: "calculator-value" }
const _hoisted_41 = { class: "calculator-button-right" }
const _hoisted_42 = { key: 5 }
const _hoisted_43 = { class: "calculator-result-table" }
const _hoisted_44 = { class: "calculator-result-table-start-col-2" }
const _hoisted_45 = { class: "calculator-result-title" }
const _hoisted_46 = { class: "calculator-result" }
const _hoisted_47 = { class: "calculator-result-table-start-col-3" }
const _hoisted_48 = { class: "calculator-result-title" }
const _hoisted_49 = { class: "calculator-result" }
const _hoisted_50 = { class: "calculator-result-table-start-col-3" }
const _hoisted_51 = { class: "calculator-result-title" }
const _hoisted_52 = { class: "calculator-result" }
const _hoisted_53 = { class: "calculator-result-table-start-col-2 calculator-result-table-start-row-2" }
const _hoisted_54 = { class: "calculator-result-title" }
const _hoisted_55 = { class: "calculator-result" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "calculator-result-line calculator-result-table-span-4" }, null, -1)
const _hoisted_57 = { class: "calculator-button-center calculator-result-table-start-col-2" }
const _hoisted_58 = { class: "calculator-button-center calculator-result-table-start-col-3" }
const _hoisted_59 = ["href"]
const _hoisted_60 = {
  key: 6,
  class: "calculator-button-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_mask = _resolveComponent("input-mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass( _ctx.currentPage === 3 ? 'calculator-box-results' : 'calculator-box')
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentPage !== 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["calculator-interaction-line", {'calculator-interaction-line-active': _ctx.currentPage > 0}])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["calculator-interaction-line", {'calculator-interaction-line-active': _ctx.currentPage > 1}])
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesNames, (pageName, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["calculator-interaction-space", {'calculator-interaction-space-done': _ctx.currentPage > index, 'calculator-interaction-space-active': _ctx.currentPage === index}]),
                  key: index,
                  onClick: ($event: any) => (_ctx.goToPage(index))
                }, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, _toDisplayString(pageName), 1)
                ], 10, _hoisted_5))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["button button--reverse button--borderless", {'button--white calculator-results-button': _ctx.currentPage === 3}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
          }, _toDisplayString(_ctx.translations.backButton), 3))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.pagesNames.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.pagesNames[0]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.translations.chooseCommodity) + " * ", 1),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodities, (commodity, index) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "form__radio form__radio--nospace",
                    key: index
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form__radio-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.grain) = $event)),
                      type: "radio",
                      value: commodity
                    }, null, 8, _hoisted_12), [
                      [_vModelRadio, _ctx.grain]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form__indicator--grey", {'form__indicator--required': _ctx.testFields && !_ctx.grain}])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(commodity), 1)
                  ]))
                }), 128))
              ]),
              (_ctx.testFields && !_ctx.grain)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.translations.requiredfield), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translations.numbAcres) + " *", 1),
                _createVNode(_component_input_mask, {
                  "initial-value": _ctx.nAcres,
                  onModelvalue: _ctx.onNAcres,
                  placeholder: "10,000",
                  requiredfield: _ctx.testFields && !_ctx.nAcres
                }, null, 8, ["initial-value", "onModelvalue", "requiredfield"]),
                (_ctx.testFields && !_ctx.nAcres)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.translations.requiredfield), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translations.marketPrice) + " *", 1),
                _createVNode(_component_input_mask, {
                  "initial-value": _ctx.marketPrice,
                  onModelvalue: _ctx.onMarketPrice,
                  placeholder: "$0",
                  dollar: "",
                  requiredfield: _ctx.testFields && !_ctx.marketPrice
                }, null, 8, ["initial-value", "onModelvalue", "requiredfield"]),
                (_ctx.testFields && !_ctx.marketPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.translations.requiredfield), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translations.yieldBu) + " *", 1),
                _createVNode(_component_input_mask, {
                  "initial-value": _ctx.yieldBu,
                  onModelvalue: _ctx.onYieldBu,
                  placeholder: "0",
                  requiredfield: _ctx.testFields && !_ctx.yieldBu
                }, null, 8, ["initial-value", "onModelvalue", "requiredfield"]),
                (_ctx.testFields && !_ctx.yieldBu)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.translations.requiredfield), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_ctx.pagesNames.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.pagesNames[1]) + " ", 1),
                  _createElementVNode("span", _hoisted_24, "(" + _toDisplayString(_ctx.translations.variableCostsOptional) + ")", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.pagesNames.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.pagesNames[1]) + " (" + _toDisplayString(_ctx.translations.variableCostsPerAcre) + ") ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.costsVariables, (cost, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'chose'+cost
                }, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(cost), 1),
                  _createVNode(_component_input_mask, {
                    "initial-value": _ctx.costsValues[index],
                    index: index,
                    dollar: "",
                    onModelvalue: _ctx.onCostsValues
                  }, null, 8, ["initial-value", "index", "onModelvalue"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_ctx.pagesNames.length > 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.pagesNames[2]), 1))
              : _createCommentVNode("", true),
            (_ctx.pagesNames.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.pagesNames[0]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", null, _toDisplayString(_ctx.translations.commodity), 1),
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.grain), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.translations.numbAcres), 1),
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.nAcres.toLocaleString('en-US')), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", null, _toDisplayString(_ctx.translations.marketPrice), 1),
                _createElementVNode("div", _hoisted_36, [
                  _createTextVNode(" $"),
                  _createElementVNode("span", null, _toDisplayString(_ctx.marketPrice.toLocaleString('en-US')), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.translations.yieldBu), 1),
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.yieldBu.toLocaleString('en-US')), 1)
              ])
            ]),
            (_ctx.pagesNames.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.pagesNames[1]) + " (" + _toDisplayString(_ctx.translations.variableCostsPerAcre) + ") ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.costsVariables, (cost, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "calculator-table",
                  key: 'chosen'+cost
                }, [
                  _createElementVNode("div", null, _toDisplayString(cost), 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createTextVNode(" $"),
                    _createElementVNode("span", null, _toDisplayString(_ctx.costsValues[index].toLocaleString('en-US')), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", {
                class: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
              }, _toDisplayString(_ctx.translations.calculate), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.translations.marketIncomeAcre), 1),
                _createElementVNode("div", _hoisted_46, " $ " + _toDisplayString(_ctx.marketIncomeAcre.toLocaleString('en-US', {minimumFractionDigits: 2})), 1)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.translations.totalCosts), 1),
                _createElementVNode("div", _hoisted_49, " $ " + _toDisplayString(_ctx.totalCosts.toLocaleString('en-US', {minimumFractionDigits: 2})), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.translations.netIncome), 1),
                _createElementVNode("div", _hoisted_52, " $ " + _toDisplayString(_ctx.netIncome.toLocaleString('en-US', {minimumFractionDigits: 2})), 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.translations.totalFarmIncome), 1),
                _createElementVNode("div", _hoisted_55, " $ " + _toDisplayString(_ctx.totalFarmIncome.toLocaleString('en-US', {minimumFractionDigits: 2})), 1)
              ]),
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", {
                  class: "button button--white button--download",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generatePDF && _ctx.generatePDF(...args)))
                }, _toDisplayString(_ctx.translations.saveResults), 1)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("a", {
                  class: "button button--white button--borderless calculator-last-button",
                  href: _ctx.contactLink,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(_ctx.translations.contactMerchandiser), 9, _hoisted_59)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 0 || _ctx.currentPage === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", {
              class: "button button--round-arrow",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
            }, _toDisplayString(_ctx.translations.nextButton), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}